export const workspaceGroups = [
  {
    id: 'research',
    label: '竞品分析文档',
    eyebrow: 'Competitive intelligence',
    entries: [
      {
        to: '/research/five-competitors',
        name: 'FiveCompetitorAnalysis',
        component: () => import(/* webpackChunkName: "research-five-competitors" */ '../views/FiveCompetitorAnalysis.vue'),
        tag: '深度分析',
        code: 'RES·01',
        title: '智能家居设计软件 · 五竞品深度分析',
        navTitle: '五竞品深度分析',
        desc: '麦哲伦平台、米案系统、家乐联、闲余全屋智能、智装大狮五家智能家居设计软件的全景拆解，含定位矩阵、逐个拆解、15 维对比与战略建议。',
        action: '打开竞品分析报告',
        featured: false
      },
      {
        to: '/research/mian-competitive',
        name: 'CompetitiveAnalysis',
        component: () => import(/* webpackChunkName: "research-mian-competitive" */ '../views/CompetitiveAnalysis.vue'),
        tag: '竞品深度分析',
        code: 'RES·02',
        title: '米案｜智能家居方案设计平台竞品深度分析',
        navTitle: '米案竞品分析',
        desc: '从专业方案设计器到智能家居垂直 ERP：业务闭环、12 项功能证据、实战技巧、视频教程、商业模式、SWOT 与战略建议。',
        action: '打开米案竞品报告'
      },
      {
        to: '/research/gouzhu-market',
        name: 'GouzhuMarketReport',
        component: () => import(/* webpackChunkName: "research-gouzhu-market" */ '../views/GouzhuMarketReport.vue'),
        tag: '竞品与市场分析',
        code: 'RES·03',
        title: '构住生活｜竞品与市场分析报告',
        navTitle: '构住生活竞品分析',
        desc: '围绕三维家/玄尺 AI 内部能力 + 标准化家具供应链，识别市场位置、外部竞品、用户价值与阶段性落地机会。',
        action: '打开市场分析报告'
      }
    ]
  },
  {
    id: 'core',
    label: '核心产品',
    eyebrow: 'Core workflows',
    entries: [
      {
        to: '/lighting-planner',
        name: 'WholeHouseLightingPlanner',
        component: () => import(/* webpackChunkName: "workflow-lighting" */ '../views/WholeHouseLightingPlanner.vue'),
        tag: '完整工作流',
        code: 'CORE·01',
        title: '全屋灯光方案系统',
        navTitle: '全屋灯光方案',
        desc: '上传户型图、录入业主信息，生成可用于导购讲解的全屋灯光布置方案。',
        action: '进入方案工作台',
        featured: true
      },
      {
        to: '/analyzer',
        name: 'FloorPlanAnalyzer',
        component: () => import(/* webpackChunkName: "workflow-analyzer" */ '../views/FloorPlanAnalyzer.vue'),
        tag: '户型理解',
        code: 'CORE·02',
        title: '智能分析',
        navTitle: '户型智能分析',
        desc: '体验现有户型识别、信息提取和分析演示流程。'
      },
      {
        to: '/designer',
        name: 'Designer',
        component: () => import(/* webpackChunkName: "workspace-designer" */ '../views/Designer.vue'),
        tag: '参数配置',
        code: 'CORE·03',
        title: '灯光设计器',
        navTitle: '3D 灯光控制',
        desc: '查看灯具参数、空间配置与方案调整能力。'
      }
    ]
  },
  {
    id: 'spatial',
    label: '空间预览',
    eyebrow: 'Spatial previews',
    entries: [
      {
        to: '/floorplan',
        name: 'FloorPlan3D',
        component: () => import(/* webpackChunkName: "spatial-floorplan" */ '../views/FloorPlan3D.vue'),
        tag: '完整空间',
        code: '3D·01',
        title: '3D 户型图',
        navTitle: '3D 户型图',
        desc: '查看完整 3D 户型和灯具配置。'
      },
      {
        to: '/living-room-spotlights',
        name: 'LivingRoomSpotlightsDemo',
        component: () => import(/* webpackChunkName: "spatial-living-room" */ '../views/LivingRoomSpotlightsDemo.vue'),
        tag: '真实氛围',
        code: '3D·02',
        title: '客厅射灯预览',
        navTitle: '客厅射灯预览',
        desc: '演示客厅射灯的真实打光氛围。'
      },
      {
        to: '/spotlights',
        name: 'SpotlightsDemo',
        component: () => import(/* webpackChunkName: "spatial-spotlights" */ '../views/SpotlightsDemo.vue'),
        tag: '交互控制',
        code: 'FX·03',
        title: '射灯开关 Demo',
        navTitle: '射灯开关',
        desc: '切换射灯开关、亮度和光色效果。'
      },
      {
        to: '/2d',
        name: 'View2D',
        component: () => import(/* webpackChunkName: "spatial-2d" */ '../views/View2D.vue'),
        tag: '平面关系',
        code: '2D·04',
        title: '2D 平面图',
        navTitle: '2D 平面图',
        desc: '快速查看户型和灯光布置关系。'
      },
      {
        to: '/3d',
        name: 'View3D',
        component: () => import(/* webpackChunkName: "spatial-3d" */ '../views/View3D.vue'),
        tag: '多角度',
        code: '3D·05',
        title: '3D 立体图',
        navTitle: '3D 立体图',
        desc: '从多个角度查看整体空间效果。'
      }
    ]
  },
  {
    id: 'technical',
    label: '技术实验',
    eyebrow: 'Technical studies',
    entries: [
      {
        to: '/editor',
        name: 'ViewEditor',
        component: () => import(/* webpackChunkName: "technical-editor" */ '../views/ViewEditor.vue'),
        tag: 'React + Vue',
        code: 'LAB·01',
        title: '3D 编辑器',
        navTitle: '3D 灯光编辑器',
        desc: 'React 与 Vue 混合的灯光编辑实验页。'
      },
      {
        to: '/gltf',
        name: 'ViewGLTF',
        component: () => import(/* webpackChunkName: "technical-gltf" */ '../views/ViewGLTF.vue'),
        tag: '模型加载',
        code: 'LAB·02',
        title: 'GLTF 查看',
        navTitle: 'GLTF 模型查看',
        desc: '加载和预览本地 GLTF / GLB 模型文件。'
      },
      {
        to: '/image-layer-demo',
        name: 'ImageLayerFadeDemo',
        component: () => import(/* webpackChunkName: "technical-image-layer" */ '../views/ImageLayerFadeDemo.vue'),
        tag: '图片叠层',
        code: 'LAB·03',
        title: '图片叠层交叉淡化',
        navTitle: '图片叠层淡化 Demo',
        desc: '以固定视角图片叠层模拟 16 个空间的灯光模式、单灯控制与交叉淡化。'
      }
    ]
  },
  {
    id: 'knowledge',
    label: '行业知识',
    eyebrow: 'Industry knowledge',
    entries: [
      {
        to: '/lighting-knowledge',
        name: 'LightingKnowledge',
        component: () => import(/* webpackChunkName: "knowledge-lighting" */ '../views/LightingKnowledge.vue'),
        tag: '行业知识库',
        code: 'KNOW·01',
        title: '照明行业知识全集',
        navTitle: '照明行业知识全集',
        desc: '手册、速查卡与示意图三合一，覆盖照明术语、灯具用途、布置规则、关键参数和行业趋势。',
        action: '打开行业知识全集',
        featured: false
      },
      {
        to: '/smart-light-book',
        name: 'SmartLightBook',
        component: () => import(/* webpackChunkName: "knowledge-smart-light-book" */ '../views/SmartLightBook.vue'),
        tag: '专题书籍',
        code: 'KNOW·02',
        title: '智能灯光：从技术实战到设计融合',
        navTitle: '智能灯光专题书籍',
        desc: '精馏版网页书籍：光学、协议、系统架构、人因照明、设计方法、工程验收与产业趋势。',
        action: '打开智能灯光知识书',
        featured: false
      },
      {
        to: '/smart-view-rules',
        name: 'SmartViewRules',
        component: () => import(/* webpackChunkName: "knowledge-smart-view-rules" */ '../views/SmartViewRules.vue'),
        tag: '规则手册',
        code: 'KNOW·03',
        title: '3D 空间智能视角规则',
        navTitle: '3D 智能视角规则',
        desc: '面向 16 类户型空间的主对象识别、相机约束、候选机位评分、降级流程与开发差距。',
        action: '打开智能视角规则',
        featured: false
      }
    ]
  }
]

export const workspaceEntries = workspaceGroups.flatMap(group => (
  group.entries.map(entry => ({
    ...entry,
    groupId: group.id,
    groupLabel: group.label,
    groupEyebrow: group.eyebrow
  }))
))

export function getWorkspaceGroup(groupId) {
  return workspaceGroups.find(group => group.id === groupId)
}

export const productProEntries = [
  {
    href: 'product-pro/gouzhu-life/构住生活_家具供应链平台_PRD.html',
    tag: '产品需求文档',
    code: 'PRO·01',
    project: '构住生活 · 家具供应链平台',
    title: '消费者商城与家具供应链平台 PRD',
    desc: '覆盖产品边界、角色权限、端到端流程、P0 功能、状态机、验收标准与版本计划。',
    scope: 'PRODUCT STRATEGY · DELIVERY'
  }
]
